import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Signal,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Actions, ofActionCompleted, ofActionErrored, ofActionSuccessful, Store } from '@ngxs/store';
import { environment } from 'apps/app-cic-ciam/src/environments/environment';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';

import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import {
  UsernameState,
  VerifyIdFailure,
  VerifyIdSuccess,
  VerifySupplierId,
  VerifyWorkerId,
} from '../../store';
import {
  FormForgotUsernameComponent,
  VerificationType,
} from '../form-forgot-username/form-forgot-username.component';
import { ClearEverything, SetLanguage } from '../../../app.actions';

@Component({
  selector: 'digitsolu-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss'],
})
export class ForgotUsernameComponent implements OnInit, OnDestroy {
  @ViewChild('forgotUsernameForm')
  forgotUsernameForm!: FormForgotUsernameComponent;

  private destroy$ = new Subject<void>();

  // isLoading: boolean = false;
  isLoading$: Signal<boolean | undefined> = toSignal(
    this.store.select(UsernameState.isLoading)
  );

  get isLoading(): boolean {
    return this.isLoading$() ?? false;
  }

  userInfo: Partial<{
    email?: string | null;
    mobilePhone?: string | null;
    workerId?: string | null;
    supplierId?: string | null;
  }> = {};

  get supportNumber(): string {
    return environment.supportNo;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private actions$: Actions,
    private readonly translate: TranslateService,
    private supportService: SupportService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.actions$
      .pipe(
        ofActionCompleted(VerifyIdSuccess, VerifyIdFailure),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        const action = event.action;

        if (action instanceof VerifyIdFailure) {
          this.toastr.error(action.error ?? 'Something went wrong');
        } else if (action instanceof VerifyIdSuccess) {
          this.router.navigate(['confirm'], { relativeTo: this.route });
        }
      });

    // Check for 'language' cookie and set language if present
    const getCookie = (): string | undefined => {
      const match = document.cookie.match(new RegExp('(^| )language=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : undefined;
    };
    const lang = getCookie();
    if (lang) {
      this.translate.use(lang);
      this.store.dispatch(new SetLanguage(lang));
    }

    this.store.dispatch(new ClearEverything());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  goToLogin($event: any) {
    $event.preventDefault();
    // this.router.navigate(['/portallogin']);
    window.close();
  }

  resetForm() {
    this.userInfo = {};
  }

  async forgotUsername(payload: {
    verificationType: VerificationType;
    id: string;
    recaptchaV2Token: string;
    recaptchaV3Token: string;
  }) {
    switch (payload.verificationType) {
      case VerificationType.workerId:
        this.store.dispatch(new VerifyWorkerId(payload.id, payload.recaptchaV2Token, payload.recaptchaV3Token));
        break;

      case VerificationType.supplierId:
        this.store.dispatch(new VerifySupplierId(payload.id, payload.recaptchaV2Token, payload.recaptchaV3Token));
        break;

      default:
        break;
    }

    // try {
    //   this.isLoading = true;
    //   const response = await this.supportService.forgotUsername(
    //     payload.verificationType == VerificationType.workerId
    //       ? payload.id
    //       : null,
    //     payload.verificationType == VerificationType.supplierId
    //       ? payload.id
    //       : null
    //   );
    //   if (response.success) {
    //     const result = response.value;
    //     if (result) {
    //       this.userInfo = result;
    //     }
    //   } else {
    //     this.toastr.error(response.errorMessage ?? 'Something went wrong');
    //   }
    // } catch (error: any) {
    //   if (error) {
    //     this.toastr.error(error ?? 'Something went wrong');
    //   }
    // } finally {
    //   this.isLoading = false;
    // }
  }

  // async sendUsername($event: any) {
  //   $event.preventDefault();

  //   try {
  //     this.isLoading = true;
  //     const response = await this.supportService.sendUsername(
  //       this.userInfo.email ? 'email' : 'sms',
  //       this.userInfo.workerId,
  //       this.userInfo.supplierId
  //     );
  //     if (response.success) {
  //       this.toastr.success(this.translate.instant('Email sent!'));
  //     } else {
  //       this.toastr.error(response.errorMessage ?? 'Something went wrong');
  //     }
  //   } catch (error: any) {
  //     if (error) {
  //       this.toastr.error(error ?? 'Something went wrong');
  //     }
  //   } finally {
  //     this.isLoading = false;
  //   }
  // }
}
